import * as redux from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import createDataDogMiddleware from '../common/logging/datadog';

export const getProdMiddlewares = () => {
    const dataDogMiddleware = createDataDogMiddleware();
    return [
        dataDogMiddleware
    ];
};


export const createStore = (rootReducer, initialState, middlewares) => {
    return redux.createStore(rootReducer, initialState,
        composeWithDevTools(redux.applyMiddleware(...middlewares)));
}
